module.exports = __webpack_public_path__ + "img/index-item1.fdfa171c.png";